import React, { useState } from "react";
import ReactGA from "react-ga4";
import { useTranslation } from "react-i18next";

import { InstagramErrorInstructions } from "./ErrorInstructions";
import { InstagramIntegrationButtons } from "./IntegrationButtons";
import {
  INSTAGRAM_INTEGRATE_LOCATION_ID_LOCAL_STORAGE_KEY,
  INSTAGRAM_INTEGRATE_LOCATION_NAME_LOCAL_STORAGE_KEY,
  INSTAGRAM_REDIRECT_URL,
} from "../../../config";
import useDeleteInstagramIntegration from "../../../containers/FacilityDetailsPage/hooks/useDeleteInstagramIntegration";
import { LocationData } from "../../../models/LocationData";
import { getInstagramData } from "../../../utils/getInstagramStatus";
import ModalConfirm from "../../ModalConfirm";
import "./styles.scss";

export interface IExternalIntegrationsProps {
  locationData: LocationData;
}

export const ExternalIntegrations: React.FunctionComponent<
  IExternalIntegrationsProps
> = (props) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityDetailsPage.externalIntegrations.${key}`);

  const { locationData } = props;

  const onIntegrateInstagram = () => {
    localStorage.setItem(
      INSTAGRAM_INTEGRATE_LOCATION_ID_LOCAL_STORAGE_KEY,
      `${locationData.id}`
    );
    localStorage.setItem(
      INSTAGRAM_INTEGRATE_LOCATION_NAME_LOCAL_STORAGE_KEY,
      `${locationData.name}`
    );
    ReactGA.event({
      category: "External Integration",
      action: "Integrate Instagram",
    });
    window.location.replace(INSTAGRAM_REDIRECT_URL);
  };

  const instagramData = getInstagramData(locationData);

  const [
    showDeleteInstagramIntegrationConfirm,
    setShowDeleteInstagramIntegrationConfirm,
  ] = useState<boolean>(false);

  const onDisconnectInstagram = () => {
    setShowDeleteInstagramIntegrationConfirm(true);
  };

  const { deleteInstagramIntegration } = useDeleteInstagramIntegration(
    locationData.id.toString(),
    locationData
  );

  return (
    <>
      <div className="white-border-panel external-integrations padding32">
        <div className="data-title">{t("instagram")}</div>
        <div className="data-content">
          <InstagramIntegrationButtons
            onDisconnectInstagram={onDisconnectInstagram}
            onIntegrateInstagram={onIntegrateInstagram}
            instagramData={instagramData}
          />
          <InstagramErrorInstructions instagramData={instagramData} />
          <small className="instagram-note">{t("instagram_note")}</small>
        </div>
      </div>
      {showDeleteInstagramIntegrationConfirm && (
        <ModalConfirm
          title={"please_confirm_to_disconnect_instagram"}
          cancelLabel={"cancel"}
          confirmLabel={"remove"}
          onClose={() => {
            setShowDeleteInstagramIntegrationConfirm(false);
          }}
          onConfirm={() => {
            deleteInstagramIntegration();
            setShowDeleteInstagramIntegrationConfirm(false);
          }}
        />
      )}
    </>
  );
};

export default ExternalIntegrations;
